import { useMemo } from 'react';

import { RyeconClock, RyeconTable, RyeconTableColumn } from '@dbt-labs/sourdough';

import { TableNode, WarehouseEntityType } from '@/__generated__/graphql';
import DetailTabs, { TabInfo } from '@/components/DetailTabs';
import { TextIconPair } from '@/pages/account/project/resource/details/components/Header';
import { ColumnsView } from '@/pages/account/project/resource/details/components/Tabs/ColumnsView';
import { formatDateWithTooltip } from '@/util/date';
import { AssetDetailsHeader } from '../AssetDetailsHeader';
import { GeneralView } from '../Tabs/GeneralView';

export const TableDetailPage = ({ asset }: { asset: TableNode | undefined }) => {
  const tabs: TabInfo[] = [
    { type: 'general' },
    { type: 'columns', count: asset?.columnCount ?? 0 },
  ];

  const lastSyncedAtDate = asset?.lastSyncedAt
    ? new Date(asset?.lastSyncedAt)
    : undefined;
  const dateInfo = lastSyncedAtDate
    ? formatDateWithTooltip(lastSyncedAtDate)
    : undefined;
  const updatedAt = dateInfo?.display;
  const updatedAtUtc = dateInfo?.tooltip;

  const headerIcons: TextIconPair[] = useMemo(
    () => [
      {
        ryecon: RyeconTable,
        text: 'Table',
      },
      ...(updatedAt
        ? [
            {
              ryecon: RyeconClock,
              text: `Last updated ${updatedAt}`,
              tooltip: updatedAtUtc || undefined,
            },
          ]
        : []),
      {
        ryecon: RyeconTableColumn,
        text: `${asset?.columnCount ?? 0} columns`,
      },
    ],
    [asset?.columnCount, updatedAt, updatedAtUtc],
  );

  return (
    <div>
      <AssetDetailsHeader
        urn={asset?.urn}
        qualifiedName={asset?.qualifiedName ?? ''}
        assetType={WarehouseEntityType.Table}
        headerIcons={headerIcons}
        title={asset?.name ?? ''}
        platform={asset?.platform ?? null}
      />
      <DetailTabs tabs={tabs} show={true}>
        {(activeTab) => {
          return (
            <>
              {activeTab === 'general' && (
                <GeneralView asset={asset} description={asset?.description} />
              )}
              {activeTab === 'columns' && asset && (
                <ColumnsView resource={asset} shouldShowLineage={false} />
              )}
            </>
          );
        }}
      </DetailTabs>
    </div>
  );
};
